import styled from 'styled-components';

export const Container = styled.div`
	padding-bottom: 1px;
`;

export const Padding20 = styled.div`
	padding: 0 20px;
`;

export const MarginTop30 = styled.div`
	margin-top: 30px;
`;

export const TrialBlockWrapper = styled.div`
	padding: 30px 20px 0;
`;

export const RealPhotoWrapper = styled.div`
	padding: 20px 0 0 0;

	h3 {
		color: #000;
		padding: 0 20px;
		font-size: 20px;
		font-weight: 500;
		line-height: 23px;
		position: relative;
	}
`;
